// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.register-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

/* Modal Container */
.register-modal {
  background-color: #000;
  width: 900px;
  max-width: 95%;
  display: flex;
  position: relative;
  border: 1px solid #fff;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  max-height: 95vh;
}
.register-modal-left{background-position: bottom;background-size: contain;background-repeat: no-repeat;}

/* Close Button */
.register-modal-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 35px;
  height: 35px;
  background-color: var(--proskins-green);
  color: #000;
  font-size: 20px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modal Content */
.register-modal-content {
  flex: 1 1;
  display: flex;
  gap: 20px;
}

/* Left Side: Golfer silhouette */
.register-modal-left {
  flex: 5 1;
}

/* Right Side: Form */
.register-modal-right {
  flex: 7 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

/* Title */
.register-modal-title {
  color: var(--proskins-green);
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
  font-family: 'Oswald', sans-serif;
}

/* Form Inputs */
.register-modal-form input {
  width: 100%;
  padding: 6px 12px;
  margin-bottom: 10px;
  background-color: #111;
  border: 1px solid #444;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
}

.register-modal-form input[type="checkbox"] {
  width: auto;
}

  /* Two-column rows */
.register-modal-row {
  display: flex;
  gap: 15px;
  margin-bottom: 5px;
}

.register-modal-row-3 {
  display: flex;
  gap: 15px;
  margin-bottom: 5px;
}

/* Password container */
.auth-password-container {
  position: relative;
  flex: 1 1;
}

.auth-password-container button {
  position: absolute;
  right: 10px;
  top: 60%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
}

/* Upload buttons */
.upload-box {
  display: inline-block;
  padding: 10px 15px;
  margin-right: 10px;
  margin-bottom: 15px;
  background-color: #111;
  color: #fff;
  border: 1px solid #444;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
}

/* Submit Button */
.register-modal-submit {
  width: 100%;
  padding: 12px;
  background-color: var(--proskins-green);
  color: #000;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 24px;
  transition: all 0.2s ease-in-out;
}

.register-modal-submit:hover {
  filter: brightness(1.1);
}

/* Error Messages */
.register-modal-error {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background-color: rgba(255, 68, 68, 0.1);
  border: 1px solid rgba(255, 68, 68, 0.3);
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  color: #ff4444;
}


.register-modal-form .input-error {
  border-color: #ff4444;
}

.register-modal-row .input-group{
  width: 50%;
}
.register-modal-form .input-group label {
  display: block;
  margin-bottom: 5px;
  color: #fff;
  font-weight: 500;
  text-align: left;
  font-family: "Poppins";
  letter-spacing: 0px;
  font-size: 12px;
}

.register-modal-form input {
  text-align: left; /* forces text inside input to align left */
}
.register-modal-right .login-modal-logo{
  margin-bottom: unset;
}
.register-modal-right .login-modal-logo-img{
  width: 100px;
  height: 100px;
}
@media (min-width: 1600px) {
  .register-modal{
    width: 1200px;
  }
  .register-modal-left{background-size: 80% !important;}
}
@media (max-width: 768px) {
  .register-modal-left{
      display: none;
  }
  .upload-box{
      margin-right: unset;
      width: 100%;
      padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/RegisterModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,qBAAqB,2BAA2B,CAAC,wBAAwB,CAAC,4BAA4B,CAAC;;AAEvG,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,SAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;EAEE,oBAAoB;AACtB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,wCAAwC;EACxC,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,2CAA2C;AAC/D;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA,qBAAqB,+BAA+B,CAAC;AACvD;AACA;EACE;MACI,aAAa;EACjB;EACA;MACI,mBAAmB;MACnB,WAAW;MACX,aAAa;EACjB;AACF","sourcesContent":["/* Modal Overlay */\n.register-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n/* Modal Container */\n.register-modal {\n  background-color: #000;\n  width: 900px;\n  max-width: 95%;\n  display: flex;\n  position: relative;\n  border: 1px solid #fff;\n  overflow-y: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  max-height: 95vh;\n}\n.register-modal-left{background-position: bottom;background-size: contain;background-repeat: no-repeat;}\n\n/* Close Button */\n.register-modal-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 35px;\n  height: 35px;\n  background-color: var(--proskins-green);\n  color: #000;\n  font-size: 20px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  z-index: 1001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Modal Content */\n.register-modal-content {\n  flex: 1;\n  display: flex;\n  gap: 20px;\n}\n\n/* Left Side: Golfer silhouette */\n.register-modal-left {\n  flex: 5;\n}\n\n/* Right Side: Form */\n.register-modal-right {\n  flex: 7;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n}\n\n/* Title */\n.register-modal-title {\n  color: var(--proskins-green);\n  font-size: 28px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  text-align: center;\n  font-family: 'Oswald', sans-serif;\n}\n\n/* Form Inputs */\n.register-modal-form input {\n  width: 100%;\n  padding: 6px 12px;\n  margin-bottom: 10px;\n  background-color: #111;\n  border: 1px solid #444;\n  color: #fff;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.register-modal-form input[type=\"checkbox\"] {\n  width: auto;\n}\n\n  /* Two-column rows */\n.register-modal-row {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 5px;\n}\n\n.register-modal-row-3 {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 5px;\n}\n\n/* Password container */\n.auth-password-container {\n  position: relative;\n  flex: 1;\n}\n\n.auth-password-container button {\n  position: absolute;\n  right: 10px;\n  top: 60%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #aaa;\n  cursor: pointer;\n}\n\n/* Upload buttons */\n.upload-box {\n  display: inline-block;\n  padding: 10px 15px;\n  margin-right: 10px;\n  margin-bottom: 15px;\n  background-color: #111;\n  color: #fff;\n  border: 1px solid #444;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center;\n}\n\n/* Submit Button */\n.register-modal-submit {\n  width: 100%;\n  padding: 12px;\n  background-color: var(--proskins-green);\n  color: #000;\n  font-weight: bold;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 24px;\n  transition: all 0.2s ease-in-out;\n}\n\n.register-modal-submit:hover {\n  filter: brightness(1.1);\n}\n\n/* Error Messages */\n.register-modal-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background-color: rgba(255, 68, 68, 0.1);\n  border: 1px solid rgba(255, 68, 68, 0.3);\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  color: #ff4444;\n}\n\n\n.register-modal-form .input-error {\n  border-color: #ff4444;\n}\n\n.register-modal-row .input-group{\n  width: 50%;\n}\n.register-modal-form .input-group label {\n  display: block;\n  margin-bottom: 5px;\n  color: #fff;\n  font-weight: 500;\n  text-align: left;\n  font-family: \"Poppins\";\n  letter-spacing: 0px;\n  font-size: 12px;\n}\n\n.register-modal-form input {\n  text-align: left; /* forces text inside input to align left */\n}\n.register-modal-right .login-modal-logo{\n  margin-bottom: unset;\n}\n.register-modal-right .login-modal-logo-img{\n  width: 100px;\n  height: 100px;\n}\n@media (min-width: 1600px) {\n  .register-modal{\n    width: 1200px;\n  }\n  .register-modal-left{background-size: 80% !important;}\n}\n@media (max-width: 768px) {\n  .register-modal-left{\n      display: none;\n  }\n  .upload-box{\n      margin-right: unset;\n      width: 100%;\n      padding: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
